import classnames from 'classnames';

interface Props {
  children?: React.ReactNode;
  className?: string;
  id?: string;
}

const ButtonFooter = (props: Props): JSX.Element => {
  const { children, className, id } = props;

  return (
    children && (
      <div id={id} className={classnames('px-md py-xs border w-full bg-white', className)}>
        {children}
      </div>
    )
  );
};

export default ButtonFooter;
